import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import styled from 'styled-components'
import { saveAs } from 'file-saver'
import JSZip from 'jszip';

import TableView from '../../../Reusable/TableView'
import { Flex, FlexColumn, CardContainer } from '../../../Reusable/Container'
import { Text, Tag } from '../../../Reusable/Text'
import { TextButton } from '../../../Reusable/Button'
import { Descriptions, Skeleton, Tooltip, Collapse } from 'antd'
import { DownOutlined, UpOutlined, CheckCircleFilled, ExclamationCircleFilled, CloseCircleFilled } from '@ant-design/icons'
import Download from "../../../../Images/download.png"
import { Image } from '../../../Reusable/Image'
import Info from '../../../../Images/info-caption.png'
import Exclamation from '../../../../Images/exclamation-icon.png'
import Done from '../../../../Images/done-progress.png'

import environment from '../../../../environment'
import { ErrorAlert } from '../../../Reusable/Alert'
import { apiPOSTReq } from '../../../../Utils/api'
import { toCurrency } from '../../../../Utils/util';

export const DescItem = styled.div`
    display: flex;
    justify-content: flex-end;
`

export const DescLabel = styled.span`
    fontWeight: 500;
    fontSize: 16;
`

class Index extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            tree: null,
            expanded: {}
        }
    }

    componentDidMount() {
        this.fetchData();
        this.fetchBusinessDataPoints();
    }

    fetchData = () => {
        const { businessId } = this.props;
        var body = {
            "BusinessId": businessId//'27650b21-ff18-4da6-a16a-acd80b0e7958'
        };

        this.setState({ loading: true })
        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/monitoring/getFinancialMetrics`, null, body, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp || {}
                if (data.result) {
                    const root = this.buildTree(data.metrics);
                    console.log(2, root)
                    this.setState({ tree: root });
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    fetchBusinessDataPoints = () => {
        const { businessId } = this.props;
        var body = {
            "BusinessId": businessId//'27650b21-ff18-4da6-a16a-acd80b0e7958'
        };

        this.setState({ loading: true })
        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/monitoring/getBusinessDataPoints`, null, body, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp || {}
                if (data.result) {
                    if (data.dataPoints && data.dataPoints.length > 0) {
                        var slowPayers = data.dataPoints.filter(x => x.name === 'SlowPayers');
                        this.setState({ slowPayers: slowPayers.length > 0 && slowPayers[0] });

                        var payerSales = data.dataPoints.filter(x => x.name === 'PayerSales');
                        this.setState({ payerSales: payerSales.length > 0 && payerSales[0] });

                        var topPayers = data.dataPoints.filter(x => x.name === 'TopPayers');
                        this.setState({ topPayers: topPayers.length > 0 && topPayers[0] });

                        var arAgingReport = data.dataPoints.filter(x => x.name === 'ARAgingReport');
                        this.setState({ arAgingReport: arAgingReport.length > 0 && arAgingReport[0] });

                        var newPayers = data.dataPoints.filter(x => x.name === 'NewPayers');
                        this.setState({ newPayers: newPayers.length > 0 && newPayers[0] });
                    }

                    this.setState({ dataPoints: data.dataPoints })
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    base64ToUint8Array = (base64) => {
        try {
            const binary = atob(base64);
            const len = binary.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            return bytes;
        } catch (e) {
            console.error("Base64 decode error:", e);
            return new Uint8Array();
        }
    }

    downloadDoc = (urls, count, zip) => {
        if (count + 1 <= urls.length) {
            const { businessId } = this.props;
            var body = {
                "BusinessId": businessId
            };

            this.setState({ loading: true })
            apiPOSTReq(`${environment.lsmBaseUrl}/lsm/monitoring${urls[count]}`, null, body, (err, resp) => {
                try {
                    const data = resp || {}
                    if (data.result) {
                        var res = data.files
                        for (const [filename, base64] of Object.entries(res)) {
                            const pdfBytes = this.base64ToUint8Array(base64);
                            if (pdfBytes.length > 0) {
                                zip.file(filename, pdfBytes);
                            } else {
                                console.warn(`Skipping empty or corrupt file: ${filename}`);
                            }
                        }

                        this.downloadDoc(urls, count + 1, zip)
                    } else {
                        throw Error(data.responseMessage || data.error)
                    }
                } catch (error) {
                    ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
                }
            })
        }
        else {
            this.setState({ loading: false })
            zip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(content, "FinancialMetrics.zip");
            });
        }
    }

    buildTree = (data) => {
        const root = { name: "Root", children: new Map(), items: [], path: "root" };
        data.forEach((item) => {
            let currentNode = root;
            let path = "root";

            item.hierarchyPath.forEach((key) => {
                path += `/${key}`;
                if (!currentNode.children.has(key)) {
                    currentNode.children.set(key, {
                        name: key,
                        children: new Map(),
                        items: [],
                        path: path
                    });
                }
                currentNode = currentNode.children.get(key);
            });

            currentNode.items.push(item);
        });

        this.setState((prevState) => ({
            expanded: {
                ...prevState.expanded,
                ['root']: true
            }
        }));

        return root;
    };

    toggleExpand = (path) => {
        this.setState((prevState) => ({
            expanded: {
                ...prevState.expanded,
                [path]: !prevState.expanded[path]
            }
        }));
    };

    constructTree = (node, depth = 0) => {
        const hasChildren = node.children && node.children.size > 0;
        const isExpanded = this.state.expanded[node.path];
        return (
            <>
                {
                    node.items.map((item) => (
                        <Descriptions.Item
                            label={(
                                <Flex start fullWidth style={{ paddingLeft: depth == 0 ? 0 : (depth - 1) * 20 }}>
                                    {/* {node.items.map((item) => ( */}
                                    <Flex key={item.id} fullWidth style={{ paddingLeft: 10 }}>
                                        <FlexColumn start style={{ width: '95%' }}>
                                            <Flex start fullWidth>
                                                {`${item.displayName} (Score: ${item.score})`}
                                                <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }}
                                                    overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                                        {item.level && <Text color='white' size='14px' noWrap>{`Level: ${item.level}`}</Text>}
                                                        <Text color='white' size='14px' noWrap>{`Score: ${item.score}`}</Text>
                                                        <Text color='white' size='14px' noWrap>{`Max Score: ${item.maxScore}`}</Text>
                                                        {item.thresholds && <Text color='white' size='14px' noWrap>{`Thresholds`}</Text>}
                                                        {item.thresholds && <Text color='white' size='14px' noWrap>{`Critical: ${item.thresholds.Critical}`}</Text>}
                                                        {item.thresholds && <Text color='white' size='14px' noWrap>{`Warning: ${item.thresholds.Warning}`}</Text>}
                                                        {item.thresholds && <Text color='white' size='14px' noWrap>{`Ideal: ${item.thresholds.Ideal}`}</Text>}
                                                        {(item.reportingPeriodStart && item.reportingPeriodEnd) && <Text color='white' size='14px' noWrap>{`Reporting Period: From ${item.reportingPeriodStart} to ${item.reportingPeriodEnd}`}</Text>}
                                                        {(!item.reportingPeriodStart && item.reportingPeriodEnd) && <Text color='white' size='14px' noWrap>{`Reporting Period: As of ${item.reportingPeriodEnd}`}</Text>}
                                                    </FlexColumn>}>
                                                    <Flex style={{
                                                        "marginLeft": 5, "marginTop": 2,"border": "2px solid #333", "borderRadius": "50%", "width": 20,
                                                        "height": 20, "alignItems": "center", "justifyContent": "center", "fontFamily": "Arial, sans-serif"
                                                    }}>
                                                        i
                                                    </Flex>
                                                </Tooltip>
                                                {
                                                    item.definition && <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }}
                                                        overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                                            Definition: {item.definition}
                                                        </FlexColumn>}>
                                                         <Flex style={{
                                                        "marginLeft": 5, "marginTop": 2,"border": "2px solid #333", "borderRadius": "50%", "width": 20,
                                                        "height": 20, "alignItems": "center", "justifyContent": "center", "fontFamily": "Arial, sans-serif"
                                                    }}>
                                                        d
                                                    </Flex>
                                                    </Tooltip>
                                                }
                                                {
                                                    item.inference && <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }}
                                                        overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                                            Inference: {item.inference}
                                                        </FlexColumn>}>
                                                        <Flex style={{
                                                        "marginLeft": 5, "marginTop": 2,"border": "2px solid #333", "borderRadius": "50%", "width": 20,
                                                        "height": 20, "alignItems": "center", "justifyContent": "center", "fontFamily": "Arial, sans-serif"
                                                    }}>
                                                        in
                                                    </Flex>
                                                    </Tooltip>
                                                }
                                                {
                                                    item.sourceSystem && <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }}
                                                        overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                                            Source: {item.sourceSystem}
                                                        </FlexColumn>}>
                                                        <Flex style={{
                                                        "marginLeft": 5, "marginTop": 2,"border": "2px solid #333", "borderRadius": "50%", "width": 20,
                                                        "height": 20, "alignItems": "center", "justifyContent": "center", "fontFamily": "Arial, sans-serif"
                                                    }}>
                                                        s
                                                    </Flex>
                                                    </Tooltip>
                                                }
                                            </Flex>
                                        </FlexColumn>
                                        <FlexColumn end style={{ width: '5%' }}>
                                            {item.downloadUrls && item.downloadUrls.length > 0 && <TextButton margin='0 5px' onClick={() => { this.downloadDoc(item.downloadUrls, 0, new JSZip()) }} rightIcon={<Image src={Download} />} />}
                                        </FlexColumn>
                                    </Flex>
                                    {/* ))} */}
                                </Flex >)
                            }
                            labelStyle={{ fontWeight: 500, fontSize: depth < 2 ? 16 : 14, }}
                        >
                            <DescItem>
                                <div key={item.id} style={{ paddingLeft: 10, marginRight: hasChildren ? 0 : 15 }}>
                                    {
                                        !item.color ?
                                            <CheckCircleFilled style={{ color: 'green' }} />
                                            :
                                            item.color == 'Green' ?
                                                <CheckCircleFilled style={{ color: 'green' }} />
                                                :
                                                item.color == 'Orange' ?
                                                    <ExclamationCircleFilled style={{ color: 'orange' }} />
                                                    :
                                                    <CloseCircleFilled style={{ color: 'red' }} />
                                    }
                                </div>
                                {
                                    node.name !== "Root" && <div
                                        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginLeft: 10 }}
                                        onClick={() => hasChildren && this.toggleExpand(node.path)}
                                    >
                                        {hasChildren ? (isExpanded ? <UpOutlined /> : <DownOutlined />) : ""}
                                    </div>
                                }
                            </DescItem>
                        </Descriptions.Item>
                    )
                    )
                }
                {
                    hasChildren && isExpanded && [...node.children.values()].map((child) =>
                        this.constructTree(child, depth + 1)
                    )
                }
            </>
        )
    }

    getAllPaths = (node) => {
        let paths = [];
        if (node.path) {
            paths.push(node.path);
        }

        for (let child of node.children.values()) {
            paths = paths.concat(this.getAllPaths(child));
        }

        return paths;
    };

    expandAll = () => {
        const { tree } = this.state;
        const allPaths = this.getAllPaths(tree);
        const expanded = {};
        allPaths.forEach(path => expanded[path] = true);
        this.setState({ expanded });
    };

    collapseAll = () => {
        this.setState({ expanded: { 'root': true } });
    };

    getSlowPayersColumns = () => {
        return [
            {
                title: 'Customer Name',
                dataIndex: 'CustomerName',
                width: '20%'
            },
            {
                title: 'Average Overdue Days',
                dataIndex: 'AverageOverdueDays',
                width: '20%'
            },
            {
                title: 'Average Days To Pay',
                dataIndex: 'AverageDaysToPay',
                width: '20%'
            },
            {
                title: 'Outstanding Invoice Balance',
                dataIndex: 'OutstandingInvoiceBalance',
                key: 'OutstandingInvoiceBalance',
                render: (item) => '$' + toCurrency(item),
                width: '20%'
            }]
    }

    getPayerSalesColumn = () => {
        return [
            {
                title: 'Customer Name',
                dataIndex: 'CustomerName',
                width: '20%'
            },
            {
                title: 'Average Net Terms',
                dataIndex: 'AverageNetTerms',
                width: '20%'
            },
            {
                title: 'Average Days To Pay',
                dataIndex: 'AverageDaysToPay',
                width: '20%'
            },
            {
                title: 'Total Sales',
                dataIndex: 'TotalSales',
                key: 'TotalSales',
                render: (item) => '$' + toCurrency(item),
                width: '20%'
            }]
    }

    getTopPayersColumn = () => {
        return [
            {
                title: 'Customer Name',
                dataIndex: 'CustomerName',
                width: '20%'
            },
            {
                title: 'Amount',
                dataIndex: 'Amount',
                key: 'Amount',
                render: (item) => '$' + toCurrency(item),
                width: '20%'
            },
            {
                title: 'Due Now',
                dataIndex: 'ARAging',
                key: 'ARAging',
                render: (item) => '$' + toCurrency(item["Due Now"]),
                width: '20%'
            },
            {
                title: '30 Days Past Due',
                dataIndex: 'ARAging',
                key: 'ARAging',
                render: (item) => '$' + toCurrency(item["30 Days Past Due"]),
                width: '20%'
            },
            {
                title: '60 Days Past Due',
                dataIndex: 'ARAging',
                key: 'ARAging',
                render: (item) => '$' + toCurrency(item["60 Days Past Due"]),
                width: '20%'
            },
            {
                title: '90 Days Past Due',
                dataIndex: 'ARAging',
                key: 'ARAging',
                render: (item) => '$' + toCurrency(item["90 Days Past Due"]),
                width: '20%'
            },
            {
                title: '120+ Days Past Due',
                dataIndex: 'ARAging',
                key: 'ARAging',
                render: (item) => '$' + toCurrency(item["120+ Days Past Due"]),
                width: '20%'
            }
        ]
    }

    getAgingReportColumn = () => {
        return [
            {
                title: 'Due Now',
                dataIndex: 'ARAgingReport',
                key: 'ARAgingReport',
                render: (item) => '$' + toCurrency(item["Due Now"]),
                width: '20%'
            },
            {
                title: '30 Days Past Due',
                dataIndex: 'ARAgingReport',
                key: 'ARAgingReport',
                render: (item) => '$' + toCurrency(item["30 Days Past Due"]),
                width: '20%'
            },
            {
                title: '60 Days Past Due',
                dataIndex: 'ARAgingReport',
                key: 'ARAgingReport',
                render: (item) => '$' + toCurrency(item["60 Days Past Due"]),
                width: '20%'
            },
            {
                title: '90 Days Past Due',
                dataIndex: 'ARAgingReport',
                key: 'ARAgingReport',
                render: (item) => '$' + toCurrency(item["90 Days Past Due"]),
                width: '20%'
            },
            {
                title: '120+ Days Past Due',
                dataIndex: 'ARAgingReport',
                key: 'ARAgingReport',
                render: (item) => '$' + toCurrency(item["120+ Days Past Due"]),
                width: '20%'
            }
        ]
    }

    getNewPayersColumn = () => {
        return [
            {
                title: 'Customer Name',
                dataIndex: 'CustomerName',
                width: '20%'
            },
            {
                title: 'Total Invoice Value',
                dataIndex: 'TotalInvoiceValue',
                key: 'TotalInvoiceValue',
                render: (item) => '$' + toCurrency(item),
                width: '20%'
            },
            {
                title: 'InvoiceCount',
                dataIndex: 'InvoiceCount',
                width: '20%'
            }
        ]
    }

    getConnectionSummary = () => {
        const { slowPayers, payerSales, topPayers, arAgingReport, newPayers } = this.state;

        const slowPayersData = slowPayers && slowPayers.dataPoints.SlowPayers || [];
        const payerSalesData = payerSales && payerSales.dataPoints.PayerSales || [];
        const topPayersData = topPayers && topPayers.dataPoints.TopPayers || [];
        const arAgingReportData = arAgingReport && [{ ARAgingReport: arAgingReport.dataPoints.ARAgingReport }] || [];
        const newPayersData = newPayers && newPayers.dataPoints.NewPayers.NewPayersAggregates || [];

        return (
            <FlexColumn between>
                <FlexColumn>
                    <Collapse bordered={true} defaultActiveKey={"slowPayers"} style={{ width: "100%" }}>
                        <Collapse.Panel header={
                            <Flex start fullWidth>Slow Payers
                                <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }}
                                    overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                        {slowPayers && slowPayers.text}
                                    </FlexColumn>}>
                                    <div style={{ float: "right", width: 30 }}>
                                        <Image src={Info} />
                                    </div>
                                </Tooltip>
                            </Flex>}
                            key="slowPayers">
                            <Flex start fullWidth style={{ marginTop: 10 }}>
                                <TableView
                                    id="debt-table"
                                    tableLayout='auto'
                                    columns={this.getSlowPayersColumns()}
                                    dataSource={slowPayersData}
                                    rowKey='id' />
                            </Flex>
                        </Collapse.Panel>
                        <Collapse.Panel header={
                            <Flex start fullWidth>Payer Sales
                                <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }}
                                    overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                        {payerSales && payerSales.text}
                                    </FlexColumn>}>
                                    <div style={{ float: "right", width: 30 }}>
                                        <Image src={Info} />
                                    </div>
                                </Tooltip>
                            </Flex>}
                            key="payerSales">
                            <Flex start fullWidth style={{ marginTop: 10 }}>
                                <TableView
                                    id="debt-table"
                                    tableLayout='auto'
                                    columns={this.getPayerSalesColumn()}
                                    dataSource={payerSalesData}
                                    rowKey='id' />
                            </Flex>
                        </Collapse.Panel>
                        <Collapse.Panel header={
                            <Flex start fullWidth>Top Payers
                                <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }}
                                    overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                        {topPayers && topPayers.text}
                                    </FlexColumn>}>
                                    <div style={{ float: "right", width: 30 }}>
                                        <Image src={Info} />
                                    </div>
                                </Tooltip>
                            </Flex>}
                            key="topPayers">
                            <Flex start fullWidth style={{ marginTop: 10 }}>
                                <TableView
                                    id="debt-table"
                                    tableLayout='auto'
                                    columns={this.getTopPayersColumn()}
                                    dataSource={topPayersData}
                                    rowKey='id' />
                            </Flex>
                        </Collapse.Panel>
                        <Collapse.Panel header={
                            <Flex start fullWidth>AR Aging Report
                                <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }}
                                    overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                        {arAgingReport && arAgingReport.text}
                                    </FlexColumn>}>
                                    <div style={{ float: "right", width: 30 }}>
                                        <Image src={Info} />
                                    </div>
                                </Tooltip>
                            </Flex>}
                            key="AgingReport">
                            <Flex start fullWidth style={{ marginTop: 10 }}>
                                <TableView
                                    id="debt-table"
                                    tableLayout='auto'
                                    columns={this.getAgingReportColumn()}
                                    dataSource={arAgingReportData}
                                    rowKey='id' />
                            </Flex>
                        </Collapse.Panel>
                        <Collapse.Panel header={
                            <Flex start fullWidth>New Payers
                                <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }}
                                    overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                        {newPayers && newPayers.text}
                                    </FlexColumn>}>
                                    <div style={{ float: "right", width: 30 }}>
                                        <Image src={Info} />
                                    </div>
                                </Tooltip>
                            </Flex>} key="newPayers">
                            <Flex start fullWidth style={{ marginTop: 10 }}>
                                <TableView
                                    id="debt-table"
                                    tableLayout='auto'
                                    columns={this.getNewPayersColumn()}
                                    dataSource={newPayersData}
                                    rowKey='id' />
                            </Flex>
                        </Collapse.Panel>
                    </Collapse>
                </FlexColumn>
            </FlexColumn>
        )
    }

    render() {
        var { tree, loading } = this.state;
        return (
            <CardContainer fullWidth>
                <Skeleton loading={loading} active title={false} paragraph={{ rows: 9 }}>
                    {
                        <Flex between fullHeight>
                            <Flex start fullWidth style={{ marginBottom: 10, gap: 8 }}>
                                <FlexColumn between fullHeight style={{ marginTop: "20px", width: '49%' }}>
                                    {!tree || (!tree.items.length && tree.children.size === 0) ?
                                        <div>No data found</div>
                                        : <>
                                            <Flex end fullWidth style={{ marginBottom: 10, gap: 8, }}>
                                                <TextButton onClick={this.collapseAll} text="Collapse All" /> | <TextButton onClick={this.expandAll} text="Expand All" />
                                            </Flex>
                                            <Descriptions
                                                bordered
                                                column={1}
                                                style={{ width: '100%' }}
                                            >
                                                {
                                                    this.constructTree(tree)
                                                }
                                            </Descriptions>
                                        </>}
                                </FlexColumn>
                                <FlexColumn fullHeight style={{ marginTop: "20px", marginLeft: 5, width: '49%' }}>
                                    <Flex start fullWidth>
                                        <Text heading>Summary</Text>
                                    </Flex>
                                    {
                                        this.getConnectionSummary()
                                    }
                                </FlexColumn>
                            </Flex>
                        </Flex>
                    }
                </Skeleton>
            </CardContainer>
        )
    }
}
function mapStateToProps(state) {
    return {
        store: state.creditAppReducer,
        aionStore: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)))